// @flow
import { createSelector } from 'reselect';
import type { State } from 'store/State';

// Constants
import { TRANSPORTATION } from 'constants/transportation';

// Selectors
import { getPolicyProperty } from 'store/reducers/dealerSettings/selectors';
import { getTranslate } from 'store/reducers/localizationString/selectors';

// Utils
import { isTrue } from 'utils/varValidation';

const { VALET, VALETLOANER, RIDESHARE } = TRANSPORTATION;

export const getApptOptions = (state: State) => state.apptOptions;

export const getAdvisors = createSelector(
  getApptOptions,
  getPolicyProperty,
  getTranslate,
  (apptOptions, getPolicyPropertyFn, getTranslate) => {
    let advisors = [];
    if (getPolicyPropertyFn('consumerAllowAnyGreeterSel')) {
      advisors.push({
        label: getTranslate('c8.appointment.any.advisor'),
        data: null
      });
    }
    if (apptOptions && apptOptions.advisors) {
      advisors = advisors.concat([...apptOptions.advisors]);
    }
    return advisors;
  }
);

export const getTransportOptions = createSelector(
  getApptOptions,
  apptOptions => {
    if (apptOptions) {
      return apptOptions.transportOptions;
    } else {
      return [];
    }
  }
);

export const isTransportationAvailable = createSelector(
  getTransportOptions,
  transportOptions => transportation => {
    if (transportation) {
      return Boolean(
        transportOptions.find(({ data }) => {
          if (transportation === VALETLOANER) {
            return data === VALET;
          }
          return data === transportation;
        })
      );
    }
    return false;
  }
);

export const isValetAvailable = createSelector(
  getTransportOptions,
  transportOptions => {
    return Boolean(transportOptions.find(({ data }) => data === VALET));
  }
);

export const allowsLoaner = createSelector(
  getTransportOptions,
  transportOptions => {
    const valetTransportationOption = transportOptions.find(
      ({ data }) => data === VALET
    );
    if (valetTransportationOption) {
      return isTrue(valetTransportationOption.configuration.ALLOW_LOANER);
    }
    return false;
  }
);

export const transportWithoutValet = createSelector(
  getTransportOptions,
  transportOptions => {
    return transportOptions.filter(({ data }) => data !== VALET);
  }
);

export const isRideshareAvailable = createSelector(
  getTransportOptions,
  transportOptions => {
    return Boolean(transportOptions.find(({ data }) => data === RIDESHARE));
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/apptOptions/selectors.js